
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M12 4.00003V2.21003C12 1.76003 11.46 1.54003 11.15 1.86003L8.35 4.65003C8.15 4.85003 8.15 5.16003 8.35 5.36003L11.14 8.15003C11.46 8.46003 12 8.24003 12 7.79003V6.00003C15.31 6.00003 18 8.69003 18 12C18 12.79 17.85 13.56 17.56 14.25C17.41 14.61 17.52 15.02 17.79 15.29C18.3 15.8 19.16 15.62 19.43 14.95C19.8 14.04 20 13.04 20 12C20 7.58003 16.42 4.00003 12 4.00003ZM12 18C8.69 18 6 15.31 6 12C6 11.21 6.15 10.44 6.44 9.75003C6.59 9.39003 6.48 8.98003 6.21 8.71003C5.7 8.20003 4.84 8.38003 4.57 9.05003C4.2 9.96003 4 10.96 4 12C4 16.42 7.58 20 12 20V21.79C12 22.24 12.54 22.46 12.85 22.14L15.64 19.35C15.84 19.15 15.84 18.84 15.64 18.64L12.85 15.85C12.54 15.54 12 15.76 12 16.21V18Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-loop`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconLoop

    ```js
    <b-new-b-icon-loop />
    ```
</docs>


